<main class="h-full w-full">
  <div class="flex h-full w-full flex-col">
    <app-trial-end-banner />
    <app-tech-issues-banner />
    <app-header />
    <div class="relative flex flex-1 transition-all duration-300">
      <router-outlet />
    </div>
  </div>
</main>

<app-modal />
<p-toast position="bottom-left" />
